/**
 * useEnsureOnboarding — garante que o cliente passou pelo onboarding antes
 * de navegar livremente pelo app.
 *
 * Roda em qualquer pagina autenticada (idealmente HomePage). Le
 * tab_clientes.ind_onboarding_completo via Supabase. Se FALSE -> redireciona
 * pra /onboarding (replace).
 *
 * Cobre o gap do login via magic link (confirmacao de email cai direto em /
 * e nao passava pela checagem do rotaPosLogin do login-page).
 *
 * Best-effort: qualquer falha (sem cliente, RLS, rede) NAO bloqueia o app.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from './auth-context';
import { supabase } from './supabase';

// Cast — coluna ind_onboarding_completo entra em database.types.ts no
// proximo `npm run db:types` apos a migration rodar.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sb = supabase as any;

export function useEnsureOnboarding(): void {
  const { user, carregando } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (carregando || !user) return;
    let cancelado = false;

    (async () => {
      try {
        const { data } = await sb
          .from('tab_clientes')
          .select('ind_onboarding_completo')
          .eq('cod_auth_user', user.id)
          .maybeSingle();
        if (cancelado) return;
        // Se a coluna nao existe ainda (migration nao aplicada) ou cliente nao encontrado,
        // o select retorna undefined / null -> nao redireciona (evita loop em dev).
        const completo = data?.ind_onboarding_completo;
        if (completo === false) {
          navigate('/onboarding', { replace: true });
        }
      } catch {
        // best-effort — jamais bloqueia o app
      }
    })();

    return () => {
      cancelado = true;
    };
  }, [user, carregando, navigate]);
}
